import React, { Component } from "react";

export default class FooterModal extends Component {

    render() {
        return <>


        </>;
    }
}